function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrapup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "17.19 7.69 17.19 6.5 6.5 6.5 6.5 19.57 6.5 25.5 8.83 25.5 8.83 19.57 17.19 19.57 17.19 20.76 25.5 20.76 25.5 7.69 17.19 7.69",
    style: {
      fill: "#E54918"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.44,
    y: 7.69,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.87,
    y: 11.25,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.44,
    y: 14.81,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.19,
    y: 12.44,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.76,
    y: 8.88,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.76,
    y: 16.01,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrapup);
export default __webpack_public_path__ + "static/media/wrapup.d61ed22c.svg";
export { ForwardRef as ReactComponent };